import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Save } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function TCSettings() {
  const { getAuthHeaders } = useAuth();
  const [s, setS] = useState({
    penalty_mode: 'fixed', penalty_value: 100,
    lockout_attempts: 3, lockout_seconds: 30,
  });
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    axios.get(`${API}/api/timeclock/settings`, { headers: getAuthHeaders() })
      .then(r => setS({ ...s, ...r.data })).catch(() => {});
    // eslint-disable-next-line
  }, []);

  const save = async () => {
    await axios.put(`${API}/api/timeclock/settings`, s, { headers: getAuthHeaders() });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-5 max-w-2xl space-y-4" data-testid="tc-settings-section">
      <h3 className="text-sm font-semibold text-slate-900">Configuracion del Checador</h3>

      <div>
        <h4 className="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wider">Penalizacion por auto-cierre</h4>
        <p className="text-xs text-slate-500 mb-2">Se aplica cuando un empleado entra pero no marca salida y el sistema cierra el registro automaticamente al fin del turno. Cada empleado puede sobreescribir esto en su ficha.</p>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-medium text-slate-600 block">Modo</label>
            <select className="w-full h-9 px-2 border border-slate-200 rounded-md text-sm"
              value={s.penalty_mode} onChange={(e) => setS({ ...s, penalty_mode: e.target.value })} data-testid="tc-set-penalty-mode">
              <option value="fixed">Monto fijo descontado del pago</option>
              <option value="minutes">Minutos descontados de horas trabajadas</option>
            </select>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block">
              {s.penalty_mode === 'fixed' ? 'Monto ($)' : 'Minutos'}
            </label>
            <Input type="number" step="0.01" value={s.penalty_value}
              onChange={(e) => setS({ ...s, penalty_value: parseFloat(e.target.value) || 0 })} data-testid="tc-set-penalty-value" />
          </div>
        </div>
      </div>

      <div>
        <h4 className="text-xs font-semibold text-slate-700 mb-2 uppercase tracking-wider">Bloqueo PIN</h4>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="text-xs font-medium text-slate-600 block">Intentos antes de bloqueo</label>
            <Input type="number" value={s.lockout_attempts}
              onChange={(e) => setS({ ...s, lockout_attempts: parseInt(e.target.value) || 3 })} />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block">Tiempo de bloqueo (segundos)</label>
            <Input type="number" value={s.lockout_seconds}
              onChange={(e) => setS({ ...s, lockout_seconds: parseInt(e.target.value) || 30 })} />
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 pt-2">
        <Button onClick={save} className="bg-[#1D3C6E] hover:bg-[#152B50]" data-testid="tc-set-save">
          <Save className="w-4 h-4 mr-1" /> Guardar
        </Button>
        {saved && <span className="text-xs text-emerald-600">Guardado</span>}
      </div>
    </div>
  );
}
